import { all, fork, takeLatest, call, put } from "redux-saga/effects";

import { getLabelingHistoryAPI } from "api/labeling-history";
import { getLabelingHistorySuccess, getLabelingHistoryError } from "./actions";
import { GET_LABELING_HISTORY } from "./constants";
import { SELECT_ONE_SOURCE_SUCCESS } from "../image/constants";

function* watchGetLabelingHistory() {
  yield takeLatest(GET_LABELING_HISTORY, function* (action) {
    const params = action.payload || {};
    const response = yield call(getLabelingHistoryAPI, params);
    if (response.success) {
      yield put(getLabelingHistorySuccess(response.data));
    } else {
      yield put(
        getLabelingHistoryError({
          msg: "Get labeling history error!",
          msgId: "notification.get-labeling-history-error",
        })
      );
    }
  });
}

function* watchSelectOneSourceSuccess() {
  yield takeLatest(SELECT_ONE_SOURCE_SUCCESS, function* (action) {
    const { sourceId } = action.payload || {};
    const response = yield call(getLabelingHistoryAPI, { sourceId });
    if (response.success) {
      yield put(getLabelingHistorySuccess(response.data));
    } else {
      yield put(
        getLabelingHistoryError({
          msg: "Get labeling history error!",
          msgId: "notification.get-labeling-history-error",
        })
      );
    }
  });
}

export default function* labelingHistorySaga() {
  yield all([fork(watchGetLabelingHistory), fork(watchSelectOneSourceSuccess)]);
}
